var parts = ['container', 'title', 'description', 'icon'];
var baseStyle = {
  container: {
    px: 3,
    borderRadius: 'lg',
    py: 2,
    fontFamily: 'body',
    lineHeight: 'base',
    fontSize: 'md'
  },
  title: {
    fontWeight: 'bold'
  },
  description: {},
  icon: {
    flexShrink: 0,
    marginEnd: 2.5,
    w: 7,
    h: 7
  }
};
function variantSolid(props) {
  var c = props.colorScheme;
  return {
    container: {
      bg: "".concat(c, ".400"),
      color: 'white'
    }
  };
}
var variants = {
  solid: variantSolid
};
var defaultProps = {
  variant: 'solid',
  colorScheme: 'blue'
};
var Banner = {
  parts: parts,
  baseStyle: baseStyle,
  variants: variants,
  defaultProps: defaultProps
};
export { Banner as default };